import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  ButtonVariant,
  PageContainer,
  PageContainerWidth,
} from '@edikk-edikk/country-layout-black';
import { RouterConfig } from '@edikk-edikk/country-frontend';
import { useHomeContext } from '#home/hooks';
import { AdvertCardList } from '#advert/components/card-list';

const AdvertList: FC = () => {
  const { mainCity, advertList } = useHomeContext();

  if (!advertList || advertList.length === 0) {
    return null;
  }

  return (
    <>
      <PageContainer width={PageContainerWidth.xl}>
        <AdvertCardList adverts={advertList} max6 />
      </PageContainer>
      <PageContainer>
        <Button
          variant={ButtonVariant.white}
          textUppercase
          pill
          navLinkProps={{
            to: mainCity.url,
            state: { routerConfig: RouterConfig.initForCity(mainCity.id) },
          }}
        >
          <FormattedMessage defaultMessage="See all models in {city}" values={{ city: mainCity.title }} />
        </Button>
      </PageContainer>
    </>
  );
};

export { AdvertList };
